import { Box, Container, Link, Typography, styled } from '@mui/material';
import { brand } from 'src/theme/brand';

const FooterWrapper = styled(Box)(
  ({ theme }) => `
        margin-top: auto;
        padding: ${theme.spacing(2, 0, 0)};
`
);

function Footer() {
  return (
    <FooterWrapper component="footer">
      <Container
        maxWidth={false}
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          flexWrap: 'wrap',
          gap: 1,
          px: { xs: 0 }
        }}
      >
        <Typography
          variant="body2"
          sx={{ color: brand.muted, fontWeight: 500, fontSize: 12 }}
        >
          &copy; {new Date().getFullYear()} LumaPOS Admin
        </Typography>
        <Typography
          variant="body2"
          sx={{ color: brand.muted, fontSize: 12 }}
        >
          Crafted by{' '}
          <Link
            href="https://efitosolutions.com/"
            target="_blank"
            rel="noopener noreferrer"
            sx={{
              fontWeight: 600,
              color: brand.green,
              textDecoration: 'none',
              '&:hover': { textDecoration: 'underline' }
            }}
          >
            efitosolutions.com
          </Link>
        </Typography>
      </Container>
    </FooterWrapper>
  );
}

export default Footer;
